<template>
  <div>
<!--     <v-tabs
      v-model="tab"
      grow
    >
      <v-tab>
        {{ $t('PROFILE.AVATAR.FACES') }}
      </v-tab>
      <v-tab>
        {{ $t('PROFILE.AVATAR.COLORS') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item> -->
        <v-row no-gutters>
          <v-col
            cols="2"
            v-for="(color, i) in colors"
            :key="i"
          >
            <div
              class="color-box mx-1"
              :class="{ 'selected': selectedColor === i }"
              @click="selectedColor = i"
            >
              <div
                class="color-square"
                :class="color[0]"
              ></div>
              <div
                class="color-square"
                :class="color[1]"
              ></div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="4"
            v-for="face in faces"
            :key="face"
          >
            <div
              class="face-box"
              :class="{ 'selected': selectedFace === face }"
              @click="selectedFace = face"
            >
              <v-img :src="getImgUrl(`${face}_${selectedColor}`)" />
              <!-- <v-img :src="getImgUrl(`${face}_0`)" /> -->
            </div>
          </v-col>
        </v-row>
      <!-- </v-tab-item>
      <v-tab-item> -->
      <!-- </v-tab-item>
    </v-tabs-items> -->
  </div>
</template>

<style scoped>
.face-box,
.color-box {
  cursor: pointer;
  opacity: .6;
}
.color-square {
  height: 13px;
}

.selected {
  border: 2px solid var(--v-primary-base);
  border-radius: 4px;
  opacity: 1;
}
</style>

<script>
export default {
  name: 'PicSelector',
  data: () => ({
    tab: 0,
    faces: ['0', '1', '2', '3', '4'],
    selectedFace: '1',
    colors: [
      ['orange', 'teal'],
      ['yellow', 'teal'],
      ['teal', 'orange'],
      ['yellow', 'orange'],
      ['yellow', 'primary'],
      ['primary', 'yellow'],
    ],
    selectedColor: 2,
  }),
  methods: {
    getImgUrl(avatar) {
      const images = require.context('@/assets/img/avatars/', false, /\.png$/);
      return images(`./${avatar}.png`);
    },
  },
  created() {
    const { pic } = this.$store.state.session;
    if (pic && pic.indexOf('_') > -1) {
      const picArray = pic.split('_');
      [this.selectedFace] = picArray;
      this.selectedColor = Number(picArray[1]);
    }
  },
};
</script>
